<template>
    <div class="page-article__content" v-if="newsItem">
        <div class="page-article__image">
            <picture>
                <source
                    :srcset="newsItem[isDeviceMobile ? 'mobileImage' : 'desktopImage'][sourceType]"
                    :type="`image/${sourceType}`"
                    v-for="(sourceType, index) in newsItem[isDeviceMobile ? 'mobileImage' : 'desktopImage'].sourcesTypes"
                    :key="index">
                <img :src="newsItem[isDeviceMobile ? 'mobileImage' : 'desktopImage'].jpg" :alt="newsItem.title"/>
            </picture>
        </div>
        <div class="page-article__top">
            <h1 v-text="newsItem.title"/>
            <router-link :to="newsItem.categoryPageUrl">{{ newsItem.categoryTitle }}</router-link>
        </div>
        <div class="page-article__description" v-html="newsItem.content"></div>
        <div class="page-article__bottom">
            <router-link :to="tag.pageUrl" v-for="tag in itemTags" :key="tag.id">{{ tag.title }}</router-link>
        </div>
    </div>
</template>

<script>
import apiData from "../../../../mixins/apiData";

export default {
    name: "NewsItemContent",

    mixins: [apiData],

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        isDeviceMobile() {
            return this.$store.state.isDeviceMobile;
        },

        isWebpSupported() {
            return this.$store.state.isWebpSupported;
        },

        locale() {
            return this.$store.state.locale;
        },

        newsSlug() {
            return this.$route.params.slug;
        },

        newsItem() {
            return this.$store.state.newsItem[this.newsSlug];
        },

        itemTags() {
            return this.newsItem && this.newsItem.tags;
        },
    },

    methods: {
        fetchData() {
            return this.$store.dispatch('FETCH_NEWS_ITEM', this.createApiData({
                slug: this.newsSlug,
            }));
        },
    }
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/NewsItemContent"
</style>